// extracted by mini-css-extract-plugin
export default {"categories__show-all":"Categories_categories__show-all__lu4ME"};